module.exports = __webpack_public_path__ + "img/order.dc3b8ea8.svg";